import axios from '@utils/axios';
import router from '@router/router';

const viewTemplate = {
  state: {
    id: null,
    template: null,
    templateEn: null,
    geneCombination: null,
    category: null,
    subCategory: null,
    genotypeCombinations: null,
    createdAt: null,
    updatedAt: null,
    createdBy: null,
    updatedBy: null,
    numberOfCombinations: 0,
    risk: 1
  },
  getters: {
    getPhenotype(state) {
      return state.geneCombination ? state.geneCombination.phenotype : '';
    },
    getGender(state) {
      return state.geneCombination ? state.geneCombination.gender : 1;
    },
    getGenotypeCombinations(state) {
      if (!state.genotypeCombinations) return null;
      const genes = Object.keys(state.genotypeCombinations[0].combination);
      const result = [];
      genes.forEach((gene) => {
        const obj = { Name: gene };
        for (let i = 0; i < state.genotypeCombinations.length; i += 1) {
          obj[i + 1] = state.genotypeCombinations[i].combination[gene];
        }
        result.push(obj);
      });
      return result;
    }
  },
  mutations: {
    setId(state, id) {
      state.id = id;
    },
    setTemplate(state, template) {
      state.template = template;
    },
    setTemplateEn(state, templateEn) {
      state.templateEn = templateEn;
    },
    setGeneCombination(state, combination) {
      state.geneCombination = combination;
    },
    setCategory(state, category) {
      state.category = category;
    },
    setSubCategory(state, subcategory) {
      state.subCategory = subcategory;
    },
    setGenotypeCombinations(state, combinations) {
      state.genotypeCombinations = combinations;
    },
    setCreatedAt(state, at) {
      state.createdAt = at;
    },
    setCreatedBy(state, by) {
      state.createdBy = by;
    },
    setNumberOfCombinations(state, number) {
      state.numberOfCombinations = number;
    },
    setUpdatedAt(state, at) {
      state.updatedAt = at;
    },
    setUpdatedBy(state, by) {
      state.updatedBy = by;
    },
    setRisk(state, risk) {
      state.risk = risk;
    }
  },
  actions: {
    fetchTemplate(context, id) {
      return axios.get('admin/templates/gettemplate', {
        params: {
          Id: id
        }
      })
        .then((res) => {
          if (res.status === 404) {
            router.push({ name: 'admin.templates.view' });
          } else if (res.status === 200) {
            context.commit('setId', id);
            context.commit('setTemplate', res.data.result.text);
            context.commit('setTemplateEn', res.data.result.textEn);
            context.commit('setGeneCombination', res.data.result.geneCombination);
            context.commit('setCategory', res.data.result.geneCombination.category);
            context.commit('setSubCategory', res.data.result.geneCombination.subcategory);
            context.commit('setGenotypeCombinations', res.data.result.genotypeCombinations);
            context.commit('setCreatedAt', res.data.result.createdAt);
            context.commit('setCreatedBy', res.data.result.createdBy);
            context.commit('setNumberOfCombinations', res.data.result.genotypeCombinations.length);
            context.commit('setUpdatedAt', res.data.result.updatedAt);
            context.commit('setUpdatedBy', res.data.result.updatedBy);
            context.commit('setRisk', res.data.result.risk);
          }
        }).catch(() => {
          router.push({ name: 'admin.templates.view' });
        });
    }
  },
  namespaced: true
};

export default viewTemplate;
